import { Page, Header, Content } from '@backstage/core-components';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

export const LandscapePage = () => {
  const config = useApi(configApiRef);
  return (
    <Page themeId="tool">
      <Header title="Landscape" />
      <Content noPadding stretch>
        <iframe
          title="Landscape"
          src={`${config.getString('backend.baseUrl')}/api/landscape/`}
          style={{ width: '100%', height: '100%', border: 0 }}
        />
      </Content>
    </Page>
  );
};
